import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast"
import { getAuthenticatedAxios } from "./use-authenticated-axios"
import type { AddWorkspaceMemberParams } from "src/internal-types"

export const useAddWorkspaceMember = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: ({ workspace_id, ...params }: AddWorkspaceMemberParams) => {
      const axios = getAuthenticatedAxios(workspace_id)

      return toast.promise(
        axios.post("/internal/workspaces/add_user", params).then((r) => r.data),
        {
          loading: `Sending invitation to ${params.email}`,
          success: `Sent invitation to ${params.email}`,
          error: `Failed to send invitation to ${params.email}`,
        }
      )
    },
    onSuccess: (_, params) => {
      qc.invalidateQueries({
        queryKey: ["workspace_members", params.workspace_id],
      })
      qc.invalidateQueries({
        queryKey: ["invited_workspace_members", params.workspace_id],
      })
    },
  })
}
